import React from 'react'
import {
  getContactMailtoHref,
  getCvMailtoHref,
  socials,
} from '../content/profile.content'
import {
  ActionLink,
  Actions,
  Avatar,
  AvatarFrame,
  Container,
  Eyebrow,
  Lead,
  Meta,
  Name,
  PrimaryAction,
  TextContent,
  Wrapper,
} from './Profile.styles'

const Profile = () => {
  return (
    <Container>
      <Wrapper>
        <TextContent>
          <Eyebrow>Software Engineer</Eyebrow>
          <Name>Oscar Osses</Name>
          <Lead>
            Available for independent projects — backend, full-stack, and
            product engineering. I help teams ship scalable systems with
            clarity and long-term craft.
          </Lead>
          <Meta>14 years experience · Dublin · Open for freelance work</Meta>
          <Actions aria-label="Contact links">
            <PrimaryAction href={getContactMailtoHref()}>
              {socials.contact.label}
            </PrimaryAction>
            <ActionLink href={getCvMailtoHref()}>
              {socials.cv.label}
            </ActionLink>
            <ActionLink
              href={socials.linkedin.href}
              rel="noopener noreferrer"
              target="_blank"
            >
              {socials.linkedin.label}
            </ActionLink>
            <ActionLink
              href={socials.github.href}
              rel="noopener noreferrer"
              target="_blank"
            >
              {socials.github.label}
            </ActionLink>
          </Actions>
        </TextContent>

        <AvatarFrame>
          <Avatar
            alt="Oscar Osses"
            fetchpriority="high"
            src="images/me.webp"
            type="image/webp"
          />
        </AvatarFrame>
      </Wrapper>
    </Container>
  )
}

export default Profile
